import { render, staticRenderFns } from "./pagination2.vue?vue&type=template&id=cd874de4&scoped=true"
import script from "./pagination2.vue?vue&type=script&lang=js"
export * from "./pagination2.vue?vue&type=script&lang=js"
import style0 from "./pagination2.vue?vue&type=style&index=0&id=cd874de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd874de4",
  null
  
)

export default component.exports